import type { FormSectionDef } from '@los-workspace/workflow-runtime';

export type PackSectionKind = 'address' | 'generic';

/** Pack fieldCode ↔ create-opportunities address-details control names. */
export const PACK_ADDRESS_FIELD_MAP: Record<string, string> = {
  addressLine1: 'textField2',
  addressLine2: 'textField3',
  pinCode: 'number2',
  city: 'textField4',
  district: 'textField5',
  state: 'textField6',
  country: 'textField7',
  addressType: 'radio2',
};

/** Legacy opportunity pack field codes wired to `app-create-address-details`. */
const OPPORTUNITY_ADDRESS_PACK_FIELD_CODES = new Set(
  Object.values(PACK_ADDRESS_FIELD_MAP),
);

export function packSectionTitle(section: FormSectionDef, index: number): string {
  if (typeof section['title'] === 'string' && section['title']) {
    return section['title'];
  }
  if (typeof section.label === 'string' && section.label) {
    return section.label;
  }
  return `Section ${index + 1}`;
}

export function resolvePackSectionKind(section: FormSectionDef, index: number): PackSectionKind {
  const title = packSectionTitle(section, index).toLowerCase();
  if (title.includes('address')) return 'address';
  return 'generic';
}

export function isAddressPackSection(section: FormSectionDef, index: number): boolean {
  const fields = section.fields ?? [];
  // Only use the dedicated address UI when the pack section actually declares
  // standard address bindings (e.g. opportunity create). Capturing "Property Address"
  // / "Address Verification" titles must stay on the generic grid.
  if (
    fields.some(
      (field) =>
        field.fieldCode === 'addressLine1' ||
        OPPORTUNITY_ADDRESS_PACK_FIELD_CODES.has(field.fieldCode),
    )
  ) {
    return true;
  }
  return fields.some((field) =>
    /address\s*line\s*1/i.test(String(field.label ?? '')),
  );
}
